import * as v from 'valibot';
export const CommonTypeBoolSchema = v.object({
    name: v.literal('bool'),
});
export const CommonTypeIntSchema = v.object({
    name: v.literal('int'),
    options: v.optional(v.object({
        min: v.number(),
        max: v.number(),
    }))
});
export const CommonTypeRealSchema = v.object({
    name: v.literal('real'),
    options: v.optional(v.object({
        min: v.number(),
        max: v.number(),
    }))
});
export const CommonTypeEnumSchema = v.object({
    name: v.literal('enum'),
    options: v.array(v.string())
});
export const CommonTypeSchema = v.union([CommonTypeBoolSchema, CommonTypeIntSchema, CommonTypeRealSchema, CommonTypeEnumSchema]);
export function prettyPrintType(t) {
    switch (t.name) {
        case 'bool':
            return 'bool';
        case 'int':
            {
                if (t.options) {
                    return 'int (' + t.options.min + ' - ' + t.options.max + ')';
                }
                else
                    return 'int';
            }
            ;
        case 'real':
            {
                if (t.options) {
                    return 'real (' + t.options.min + ' - ' + t.options.max + ')';
                }
                else
                    return 'real';
            }
            ;
        case 'enum':
            return 'enum(' + t.options.join(', ') + ')';
    }
}
